import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import HeaderCart from '../../components/HeaderCart';
const CouponScreen = () => {
  const user = useSelector((state) => state.user);
  const [state, setState] = useState('current');

  return (
    <div>
      <HeaderCart titre={'Mes coupons'} />
    </div>
  );
};

export default CouponScreen;
